/**
 * Nomi che non identificano una persona: segnaposto creati dal CRM (es. i numeri del
 * gruppo WhatsApp inseriti alla firma diventano "Referente WhatsApp") o etichette
 * generiche. Nella lista chat vanno scartati a favore del nome vero o del numero.
 */
const PLACEHOLDERS = [/^referente whatsapp$/i, /^contatto( whatsapp)?$/i, /^whatsapp \+?\d+$/i, /^nuovo contatto$/i];

export function isPlaceholderContactName(name: string | null | undefined): boolean {
  const n = (name || '').trim();
  if (!n) return true;
  return PLACEHOLDERS.some((re) => re.test(n));
}
